// Vue Router's `fullPath` keeps the fragment percent-encoded while `route.hash`
// is decoded, so a length-based subtraction between them corrupts the key.
export const routeContentKey = (fullPath: string): string =>
  fullPath.split("#")[0];
